import React from 'react';

import axios from 'axios';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import MaskedInput from 'react-text-mask';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import DayIcon from '@material-ui/icons/Phone';
import TimeIcon from '@material-ui/icons/Timer';

import InfoDialog from './InfoDialog';

import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6



function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  }

export class RequestInformation extends React.Component {
    constructor(props){
      super(props);
      this.state = {activeStep: 0,Contact:{},Day:'Any Day',Time:'Anytime',Service:'General Information'};

      this.getContactValue = this.getContactValue.bind(this);
      this.handleContactChange = this.handleContactChange.bind(this);

      this.handleValueChange = this.handleValueChange.bind(this);
      this.fileInputChanged = this.fileInputChanged.bind(this);

      this.showAxiosError = this.showAxiosError.bind(this);
    }
    showAxiosError(error){
      if(error.response && error.response.data){
          this.infoDialog.show(error.response.data,"ERROR: " +error.response.status,true);
      }else{
          this.infoDialog.show(JSON.stringify(error),"ERROR",true);
      }
    }
    getContactValue(field){
      return this.state.Contact[field];
    }
    handleContactChange = (field,value) => {
      const temp = this.state.Contact;
      temp[field] = value;
      this.setState({Contact:temp});
    }
    fileInputChanged(){
      this.file = this.fileInput.files[0];
    }
    removeFromString(str,item){
      if(!str){
        return str;
      }
      var items = str.split(';');
      var index = items.indexOf(item);
      if(index >= 0){
        items.splice(index,1);
      }
      return items.join(';')
    }
    addToString(str,item){
      if(!str){
        return item;
      }
      var items = str.split(';');
      var index = items.indexOf(item);
      if(index >= 0){
        return str;
      }else{
        items.push(item);
        return items.join(';');
      }
    }
    getValueState(exclusive,value,field){
      if(value === exclusive){
        return this.state[field] === value;
      }else{
        return (this.state[field] || '').indexOf(value) > -1;
      }
    }
    handleValueChange(exclusive,value,field,checked){
      if(checked){
        if(value === exclusive){
          const temp = {};
          temp[field] = value;
          this.setState(temp);
        }else{
          var vv = this.state[field];
          vv = this.removeFromString(vv,exclusive);
          vv = this.addToString(vv,value);
          const temp = {};
          temp[field] = vv;
          this.setState(temp);
        }
      }else{
        if(value === exclusive){
          const temp = {};
          temp[field] = value;
          this.setState(temp);
        }else{
          const vv = this.removeFromString(this.state[field],value);
          const temp = {};
          temp[field] = vv;
          this.setState(temp);
        }
      }
    }
    createRichTextBox(key){
      const modules = {
        toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }], ['bold', 'italic', 'underline','strike', 'blockquote'],[{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],['link'],[{'color':[]},{ 'background': [] }],['clean']],
      };
      const formats = ['size','bold', 'italic', 'underline', 'strike', 'blockquote','list', 'bullet', 'indent','link','color','background'];
      return(
        <div>
          <ReactQuill style={{height:'10em',marginBottom:'5em'}} theme='snow' modules={modules} formats={formats}
            value={this.state.AdditionalInformation || ''} onChange={value => this.setState({AdditionalInformation:value})}/>
        </div>
      );
    }
    createTextField(label,marginRight = '20em'){
      return (<TextField style={{flex: 1,marginRight:marginRight}} onChange={e => this.handleContactChange(label,e.target.value)} label={label} value={this.getContactValue(label)}/>)
    }
    getSteps() {
      return ['Please provide contact information', 'Best time to call', 'CastleGarde Services','Additional Information'];
    }
    getStepContent(step) {
      switch (step) {
        case 0:
          return (
          <form noValidate autoComplete="off">
              <div style={{display:'flex'}}>
                  {this.createTextField('First Name','5em')}
                  {this.createTextField('Last Name')}
              </div>
              <div style={{display:'flex'}}>
                  {this.createTextField('Credit Union Name')}  
              </div>
              <div style={{display:'flex'}}>
                  {this.createTextField('Street')}  
              </div>
              <div style={{display:'flex'}}>
                  {this.createTextField('City','5em')}
                  {this.createTextField('State')}
                  {this.createTextField('Zip')}
              </div>
              <div style={{display:'flex'}}>
                  <TextField style={{flex: 1,marginRight:'50em'}} error={this.state.Contact.Email 
                  && !this.isValidateEmail(this.state.Contact.Email)}
                  onChange={e => this.handleContactChange('Email',e.target.value)} label={'Email'} 
                  value={this.getContactValue('Email')}/>
              </div>
              <div style={{display:'flex',marginBottom:'3em'}}>
                  <FormControl  style={{flex: 1,marginRight:'50em'}}>
                      <InputLabel htmlFor="formatted-text-mask-input">Telephone</InputLabel>
                          <Input
                              defaultValue={'(  )    -    '}
                              id="formatted-text-mask-input"
                              inputComponent={TextMaskCustom}
                              value={this.getContactValue('Telephone')}
                              onChange={e => this.handleContactChange('Telephone',e.target.value)}
                          />
                  </FormControl>
              </div>
          </form>
          );
        case 1:
          return (
              <div style={{display:'flex'}}>
                      <List style={{flex:1,marginRight:'20em'}}>
                          {['Any Day','Monday','Tuesday','Wednesday','Thursday','Firday'].map(day => (
                              <ListItem key={day} dense button>
                                  <Checkbox checked={this.getValueState('Any Day',day,'Day')} style={{color:'green'}}
                                  onChange={e => {this.handleValueChange('Any Day',day,'Day',e.target.checked)}}/>
                                  <ListItemText primary={day}/>
                                  <ListItemSecondaryAction>
                                      <IconButton>
                                          <DayIcon/>
                                      </IconButton>
                                  </ListItemSecondaryAction>
                              </ListItem>
                          ))}
                      </List>
                  <List style={{flex:1,marginRight:'20em'}}>
                          {['Anytime','Early Morning','Mid Morning','Mid Day','Early Afternoon','Mid Afternoon','Late Afternoon'].map(time => (
                              <ListItem key={time} dense button>
                                  <Checkbox checked={this.getValueState('Anytime',time,'Time')} style={{color:'green'}}
                                  onChange={e => {this.handleValueChange('Anytime',time,'Time',e.target.checked)}}/>
                                  <ListItemText primary={time}/>
                                  <ListItemSecondaryAction>
                                      <IconButton>
                                          <TimeIcon/>
                                      </IconButton>
                                  </ListItemSecondaryAction>
                              </ListItem>
                          ))}
                      </List>
              </div>
          );
        case 2:
          return (
              <div style={{display:'flex'}}>
              {[
                ['General Information','Information Security Programs','Risk Assessment Programs','Compliance'],
                ['Policy and Procedures','Penetration Testing','Bank Secrecy','Business Continuity'],
                ['Training','Red Flag Identity Theft','Something else','All the above']
              ].map(serviceArray => (
                <List style={{flex:1,marginRight:'1em'}}>
                      {serviceArray.map(service => (
                          <ListItem key={service} dense button>
                              <Checkbox checked={this.getValueState('All the above',service,'Service')} color='primary'
                                  onChange={e => {this.handleValueChange('All the above',service,'Service',e.target.checked)}}/>
                              <ListItemText primary={service}/>
                          </ListItem>
                          ))}
                  </List>
              ))}
              </div>
          );
        case 3:
          return (
              <div>
                  <label style={{fontWeight:'bold'}}>Enter additional information - 1000 characters max.:</label>
                  {this.createRichTextBox()}
                  <div style={{marginBottom: '1em'}}/>
                  <label style={{fontWeight:'bold'}}>If you have a document accessable by your PC, you can upload it now.  We 
support Adobe .pdf, MS/Word .doc, WordPerfect .wpd, plain text .txt, Rich Text 
Format .rtf, Excel .xls fiel types.</label>
                  <input onChange={this.fileInputChanged} ref={ref => this.fileInput = ref} type='file' id='file'/>
                  <div style={{marginBottom: '2em'}}/>
              </div>
          );
        default:
          return 'Unknown step';
      }
    }
    handleNext = () => {
        this.setState(state => ({
          activeStep: state.activeStep + 1,
        }));
      };
    
      handleBack = () => {
        this.setState(state => ({
          activeStep: state.activeStep - 1,
        }));
      };
    
      handleReset = () => {
        this.setState({
          activeStep: 0,
        });
      };
      
      handleSubmit = () => {
        axios.get('/api/ri/key')
        .then(response => {
            const id = response.data;

            if(this.file){
                let data = new FormData();
                data.append('file',this.file,this.file.name);
                axios.post('api/ri/upload/'+id,
                  data,
                  {
                      headers: {
                          'accept': 'application/json',
                          'Accept-Language': 'en-US,en;q=0.8',
                          'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                        }
                  }
                  ).then(response => {
                      const data = JSON.parse(JSON.stringify(this.state));
                      delete data.activeStep;
            
                      axios.post('/api/ri/submitinformation/'+id,data)
                      .then(response => {
                          this.file = null;
                          this.infoDialg.show("Your request information is sent to CastleGarde successfully, we will contact you soon","SUCCESS",false);
                          this.setState({activeStep:0});
                      })
                      .catch(this.showAxiosError);
                  })
                  .catch(error => alert(error.message));
              }else{
                  const data = JSON.parse(JSON.stringify(this.state));
                  delete data.activeStep;
          
                  axios.post('/api/ri/submitinformation/'+id,data)
                  .then(response => {
                    this.infoDialg.show("Your request information is sent to CastleGarde successfully, we will contact you soon","SUCCESS",false);
                    this.setState({activeStep:0});
                  })
                  .catch(this.showAxiosError);
              }
        })
        .catch(this.showAxiosError);
      };
    isValidateEmail(email){
        const regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)/;
        return regex.test(email);
    }
    render(){
        const steps = this.getSteps();
    const { activeStep } = this.state;
        return (
            <div> 
                <Toolbar style={{ backgroundColor: '#eee', boxShadow:'3px 3px #ccc', borderRadius:'3px' }}>
                     <Typography variant="h6" color="inherit">
                                Request Information
                     </Typography>
                </Toolbar>

                
                
                
                <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
              <StepContent>
                <Typography>{this.getStepContent(index)}</Typography>
                <div>
                  <div>
                    <Button
                      disabled={activeStep === 0}
                      onClick={this.handleBack}
                    >
                      Back
                    </Button>
                    
                    <Button 
                      variant="contained"
                      color="primary"
                      onClick={this.handleNext}
                    >
                      {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                  </div>
                </div>
              </StepContent>
            </Step>
          ))}
        </Stepper>
        {activeStep === steps.length && (
          <Paper square elevation={0} >
            <Typography>All steps completed - you&apos;re finished</Typography>
            <Button onClick={this.handleReset}>
              Reset
            </Button>
            <Button onClick={this.handleSubmit} color='primary' variant='contained'>
              Submit
            </Button>
          </Paper>
        )}
              <InfoDialog ref = {ref => this.infoDialg = ref}/>
            </div>
        );
    }
}